import React from 'react';
import { UserStatus } from '../../types/admin';

/**
 * Visual status indicator for user status
 * Requirements: 11.1, 11.3
 */
interface UserStatusBadgeProps {
  status: UserStatus;
}

const UserStatusBadge: React.FC<UserStatusBadgeProps> = ({ status }) => {
  const getStatusStyles = () => {
    switch (status) {
      case UserStatus.ACTIVE:
        return 'bg-emerald-100 text-emerald-800 border-emerald-300';
      case UserStatus.INACTIVE:
        return 'bg-gray-100 text-gray-800 border-gray-300';
      case UserStatus.PENDING_SYNC:
        return 'bg-amber-100 text-amber-800 border-amber-300';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-300';
    }
  };

  const getStatusLabel = () => {
    switch (status) {
      case UserStatus.PENDING_SYNC:
        return 'Pending Sync';
      default:
        return status;
    }
  };

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${getStatusStyles()}`}>
      {getStatusLabel()}
    </span>
  );
};

export default UserStatusBadge;
